import React from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/async';

import Menu from './menu';
import Option from './option';
import ValueContainer from 'helpers/react_select/components/search_value_container';
import { applyStyleOverrides } from 'helpers/react_select_helpers';
import { debouncedSearchContacts } from 'bundles/backoffice/contacts/api';

import './styles.scss';

export default class ContactSelect extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }),
    disabled: PropTypes.bool,
    iconClassName: PropTypes.string,
    limitToType: PropTypes.oneOf(['business', 'person']),
    menuPlacement: PropTypes.string,
    styles: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    // TODO: Support empty states without creation and make this optional
    onCreateClick: PropTypes.func.isRequired
  }

  get contactTypeLabel() {
    return this.props.limitToType === 'business' ? 'company' : 'contact';
  }

  get contactTypeLabelPlural() {
    return this.props.limitToType === 'business' ? 'companies' : 'contacts';
  }

  get styles() {
    return applyStyleOverrides(this.props.styles, ValueContainer.styleOverrides);
  }

  searchContacts = (query, callback) => {
    if (query) {
      const params = { query };

      if (this.props.limitToType) {
        params.type = this.props.limitToType;
      }

      debouncedSearchContacts(params, callback);
    } else {
      callback([]);
    }
  }

  render() {
    return (
      <AsyncSelect
        aria-label="search"
        className="contact-selector"
        classNamePrefix=""
        components={{ DropdownIndicator: null, Menu, Option, ValueContainer }}
        contactTypeLabel={this.contactTypeLabel}
        contactTypeLabelPlural={this.contactTypeLabelPlural}
        getOptionLabel={contact => contact.displayName}
        getOptionValue={contact => contact.id}
        isClearable
        isDisabled={this.props.disabled}
        loadOptions={this.searchContacts}
        menuPlacement={this.props.menuPlacement}
        placeholder={`Enter ${this.contactTypeLabel} name or email`}
        styles={this.styles}
        value={this.props.contact}
        onChange={this.props.onChange}
        onCreateClick={this.props.onCreateClick}
      />
    );
  }
}
